module.exports = __webpack_public_path__ + "static/media/mobile-logo.6145d469.png";